import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRoute, useRouter } from 'vue-router'
import { onUnmounted, computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MicroView',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const routeName = computed((): string => {
  const domain = route.name ? `${route.name.toString().split('-')[0]}` : ''
  return domain
})

onUnmounted(() => {
  if (routeName.value) {
    router.removeRoute(routeName.value)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})